import { derived } from "svelte/store";

import { getApiStaticData } from "../openApiConfig";
import { speciesFilterChecked } from "../main";
import type { APISpecies } from "@EMSXVET/emsx-fetch-map-app/dist/models";

type APISpeciesWithChecked = APISpecies & {
  isChecked: boolean;
  filterGroup: string;
};

export const getStaticSpecies = derived(
  [speciesFilterChecked],
  ([$checkList], set) => {
    getApiStaticData()
      .staticSpeciesApiStaticDataSpeciesGet()
      .then(response => {
        let items: APISpeciesWithChecked[] = JSON.parse(
          JSON.stringify(response.items),
        );
        items = items.map(item => {
          if ($checkList.includes(item.id)) {
            item = { ...item, isChecked: true, filterGroup: "species" };
          } else {
            item = { ...item, isChecked: false, filterGroup: "species" };
          }
          return item;
        });
        set(items);
      })
      .catch(error => {
        console.log(error);
        set([]);
      });
  },
);
